import { AlgorithmsGetRequestParams } from "@lib/core";

export interface AlgorithmDefaultParams extends AlgorithmsGetRequestParams { }
export class AlgorithmDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}